import React, { useState, useEffect, useContext } from "react";
import {
  QBSubjectnames,
} from "../../../ReusableComponents/CommonFunctions";
import { useNavigate, useLocation } from "react-router-dom";
import FilterScenario from "./FilterScenario";
import FilterQuestion from "./FilterQuestion";
import { useSelector, useDispatch } from "react-redux";
import FilterEScenario from "./FilterEScenario";
import { GetScenarioDetails, GetEnglishScenarioDetails } from "../../../ReusableComponents/CommonApis";
import { LoadContext } from "../../../ReusableComponents/LoadingContex";
const FilterSQ = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { SetLoad } = useContext(LoadContext);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const FQuestionDetails = useSelector((state) => state.FQDetails.FQDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const [SQSelect, SetSQSelect] = useState("Questions");
  const [QCOunt, SetQcount] = useState();
  const Tabs = [
    { Name: "Scenario", Value: "Scenario" },
    { Name: `Questions (${QCOunt})`, Value: "Questions" },
  ];
  const swapping = async (e) => {

    if (e === "Scenario") {
      (items.subjectId == "3" ?
        await GetEnglishScenarioDetails(location?.state?.SID, dispatch, navigate, SetLoad, location, true)
        :
        await GetScenarioDetails(SelectLanguage, location?.state?.SID, dispatch, navigate, SetLoad, location, true))
      SetSQSelect(e);
    } else {
      SetSQSelect(e);
    }
  };
  return (
    <>
      {items.subjectId !== "3" && (
        <div className="dflex alignitems">
          {QBSubjectnames(items.subjectId)}
          {items.subjectId == "3" ? (
            <>
              {!FQuestionDetails?.grammarName && "> "}{" "}
              {FQuestionDetails?.level1Name}{" "}
              {!FQuestionDetails?.grammarName && "> "}{" "}
              {FQuestionDetails?.level2Name}{" "}
              {!FQuestionDetails?.grammarName && "> "}{" "}
              <b className="text-success">
                {FQuestionDetails?.level3Name || FQuestionDetails?.grammarName}
              </b>{" "}
            </>
          ) : (
            <>
              {" "}
              {FQuestionDetails.topicName} &gt; {FQuestionDetails.subTopicName}{" "}
              &gt; <b className="text-success"> {FQuestionDetails.loName}</b>
            </>
          )}
        </div>
      )}

      <div className="dflex JCCenter gap-3">
        {Tabs.map((Item, index) => (
          <div className="dflex alignitems" style={{ gap: "5px" }}>
            <input
              type="Radio"
              name="FSQ"
              checked={Item.Value === SQSelect}
              value={Item.Value}
              onChange={(e) => swapping(e.target.value)}
            />{" "}
            <b>{Item.Name}</b>
          </div>
        ))}
      </div>
      {SQSelect === "Scenario" ? (
        items["subjectId"] === "3" ? <FilterEScenario /> :
          <FilterScenario />
      ) : (
        <FilterQuestion Count={SetQcount} />
      )}
    </>
  );
};
export default FilterSQ;